import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function TagsPlaceholder() {
  return (
    <Component>
      <Tag />
      <Tag />
      <Tag />
      <Tag />
      <Tag />
      <Tag />
    </Component>
  );
}

export default TagsPlaceholder;

const Component = styled.div`
  margin-top: 20px;
  display: flex;
`;

const Tag = styled.div`
  height: 36.1px;
  width: 50px;
  margin: 0 5px 5px 0;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 30px;
    width: 40px;
  `)}

  ${media.mobile(css`
    height: 30px;
    width: 40px;
  `)}
`;
